import { Route, Routes as RoutesContainer } from 'react-router';
import { Gym, Create, Edit, GymList } from '../index';

const Routes = () => {
  return (
    <RoutesContainer>
      <Route exact path='/gym' element={<Gym />} />
      <Route exact path='/gym/create' element={<Create />} />
      <Route exact path='/gym/edit/:id' element={<Edit />} />
      <Route exact path='/gym/list' element={<GymList />} />
    </RoutesContainer>
  );
};
export default Routes;
